import React, { useState } from "react";
import { StickyNote } from "lucide-react";
import { Button } from "@/components/ui/button";
import NoteFormDialog from "@/components/NoteFormDialog";

export default function QuickNoteButton({ recordType, recordId, recordName, size = "sm" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size={size} onClick={() => setOpen(true)} data-testid="quick-note-btn">
        <StickyNote className="h-3.5 w-3.5 mr-1.5" /> Quick Note
      </Button>
      <NoteFormDialog
        open={open}
        onClose={() => setOpen(false)}
        prefillLink={{ type: recordType, id: recordId, name: recordName }}
        lockLink
      />
    </>
  );
}
